import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHungary = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#f0f0f0",
			d: "M16 167a255.5 255.5 0 0 0 0 178l240 22.3L496 345a255.4 255.4 0 0 0 0-178l-240-22.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#d80027",
			d: "M256 0A256 256 0 0 0 16 167h480A256 256 0 0 0 256 0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6da544",
			d: "M256 512a256 256 0 0 0 240-167H16a256 256 0 0 0 240 167z"
		})
	]
});
export default SvgHungary;
